var map = {
	"./address/routes.js": 357,
	"./companies/routes.js": 360,
	"./cost/routes.js": 363,
	"./customers/routes.js": 366,
	"./deals/routes.js": 369,
	"./finance/routes.js": 372,
	"./logs/routes.js": 375,
	"./module/routes.js": 377,
	"./reports/routes.js": 379,
	"./stock/routes.js": 382,
	"./storekeepers_stocks/routes.js": 385,
	"./tasks/routes.js": 388,
	"./users/routes.js": 391
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1298;


//////////////////
// WEBPACK FOOTER
// ./src/modules routes\.js$
// module id = 1298
// module chunks = 0